var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"nofillpath",attrs:{"fill":"none","d":"M6.25 7.5L3.75 5L6.25 2.5","stroke":"#3C4043","stroke-opacity":"0.99","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})
}
var staticRenderFns = []

export { render, staticRenderFns }